import { AGUARDANDO_INSPECAO, EM_CRIACAO } from '../constants/status';

export const RESULTADO_AUDITORIA = {
  VALIDO: 'VALIDO',
  INVALIDO: 'INVALIDO',
  CANCELADO: 'CANCELADO',
};

export const ORIGEM_ARQUIVO = {
  RFG_TERCEIRIZADA_INSPECAO: 'RFG_TERCEIRIZADA_INSPECAO',
  RFG_TERCEIRIZADA_EXECUCAO: 'RFG_TERCEIRIZADA_EXECUCAO',
  APP_INSPETOR: 'APP_INSPETOR',
};

export const PARSE_RFG_UPLOAD_FIELD = 'arquivo';
export const PARSE_RFG_DEFAULT_NOME = 'RFG';
export const PARSE_RFG_CONFLICT_REPLACE_DEFAULT =
  'Já existe um RFG processado para esta NSIR. Confirme a substituição para continuar.';
export const PARSE_RFG_CONFLICT_AGUARDANDO_DEFAULT =
  'Esta NSIR está em Aguardando Inspeção. Alinhe com o inspetor antes de importar o RFG. Se já alinhou, pode seguir.';
export const PARSE_RFG_CONFLICT_DELETE_NSMP =
  'A confirmação apaga todos os Nsmp do tipo Serviço desta NSIR e recria a lista a partir do novo RFG.';
export const PARSE_RFG_CONFLICT_REPLACE_DELETE_NSMP =
  'A substituição apaga todos os Nsmp do tipo Serviço desta NSIR e recria a lista a partir do novo arquivo.';

export const canImportParseRfg = (status) =>
  status === EM_CRIACAO || status === AGUARDANDO_INSPECAO;

export const isParseRfgAguardandoInspecaoConflict = (conflict, nsirStatus) => {
  if (nsirStatus === AGUARDANDO_INSPECAO) return true;
  const text = typeof conflict === 'string' ? conflict : '';
  return /aguardando inspe/i.test(text);
};

export const PARSE_RFG_ACCEPT = [
  'application/pdf',
  '.pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.xls',
  '.xlsx',
].join(',');

export const isParseRfgPdfNome = (nome) => /\.pdf$/i.test(String(nome || ''));
export const isParseRfgExcelNome = (nome) => /\.(xlsx|xls)$/i.test(String(nome || ''));
export const isAllowedParseRfgFile = (file) => {
  if (!file || !file.name) return false;
  return isParseRfgPdfNome(file.name) || isParseRfgExcelNome(file.name);
};

export const PARSE_RFG_UPLOAD_PATH = (nsirId, { force } = {}) => {
  const base = `nsirs/${nsirId}/auditoria-faixa/rfg`;
  return force ? `${base}?force=true` : base;
};

export const PARSE_RFG_JOB_PATH = (jobId) => `nsirs/auditoria-faixa/rfg/${jobId}`;
export const PARSE_RFG_DOCUMENTO_PATH = (jobId) => `nsirs/auditoria-faixa/rfg/${jobId}/documento`;

const PARSE_RFG_JOB_STORAGE_PREFIX = 'eletropontes.parseRfgJob.';
const PARSE_RFG_FRESH_UPLOAD_PREFIX = 'eletropontes.parseRfgFreshUpload.';

export const rememberParseRfgJobId = (nsirId, jobId) => {
  if (!nsirId || !jobId) return;
  try {
    sessionStorage.setItem(`${PARSE_RFG_JOB_STORAGE_PREFIX}${nsirId}`, jobId);
  } catch (error) {
    // storage indisponível
  }
};

export const readParseRfgJobId = (nsirId) => {
  if (!nsirId) return null;
  try {
    return sessionStorage.getItem(`${PARSE_RFG_JOB_STORAGE_PREFIX}${nsirId}`);
  } catch (error) {
    return null;
  }
};

export const forgetParseRfgJobId = (nsirId) => {
  if (!nsirId) return;
  try {
    sessionStorage.removeItem(`${PARSE_RFG_JOB_STORAGE_PREFIX}${nsirId}`);
  } catch (error) {
    // storage indisponível
  }
};

/** Após upgrade false→true: exige anexo novo e não hidrata job antigo desta sessão. */
export const rememberParseRfgFreshUpload = (nsirId) => {
  if (!nsirId) return;
  try {
    sessionStorage.setItem(`${PARSE_RFG_FRESH_UPLOAD_PREFIX}${nsirId}`, '1');
  } catch (error) {
    // storage indisponível
  }
};

export const readParseRfgFreshUpload = (nsirId) => {
  if (!nsirId) return false;
  try {
    return sessionStorage.getItem(`${PARSE_RFG_FRESH_UPLOAD_PREFIX}${nsirId}`) === '1';
  } catch (error) {
    return false;
  }
};

export const forgetParseRfgFreshUpload = (nsirId) => {
  if (!nsirId) return;
  try {
    sessionStorage.removeItem(`${PARSE_RFG_FRESH_UPLOAD_PREFIX}${nsirId}`);
  } catch (error) {
    // storage indisponível
  }
};

export const isParseRfgJobOwnedByNsir = (job, nsirId) => {
  if (!job || !nsirId) return false;
  const ownerId = job.nsirId || job.entityId || null;
  return ownerId === nsirId;
};

export const getParseRfgApiMessage = (error, fallback) => {
  const data = error && error.response && error.response.data;
  if (!data) return fallback;
  return data.message || data.mensagem || fallback;
};

export const RESULTADO_AUDITORIA_OPTIONS = [
  { id: RESULTADO_AUDITORIA.VALIDO, nome: 'Conforme' },
  { id: RESULTADO_AUDITORIA.INVALIDO, nome: 'Não conforme' },
];

export const RESULTADO_AUDITORIA_LABEL = {
  [RESULTADO_AUDITORIA.VALIDO]: 'Conforme',
  [RESULTADO_AUDITORIA.INVALIDO]: 'Não conforme',
  [RESULTADO_AUDITORIA.CANCELADO]: 'Cancelado pela empreiteira',
};

export const isResultadoCancelado = (value) => value === RESULTADO_AUDITORIA.CANCELADO;

export const isFotoRfgInspecao = (arquivo) =>
  arquivo && arquivo.origem === ORIGEM_ARQUIVO.RFG_TERCEIRIZADA_INSPECAO;

export const isFotoRfgExecucao = (arquivo) =>
  arquivo && arquivo.origem === ORIGEM_ARQUIVO.RFG_TERCEIRIZADA_EXECUCAO;

export const isFotoRfg = (arquivo) =>
  isFotoRfgInspecao(arquivo) || isFotoRfgExecucao(arquivo);

export const parseCoordNumber = (value) => {
  if (value == null || value === '') return null;
  const n = Number(String(value).trim().replace(',', '.'));
  return Number.isFinite(n) ? n : null;
};

export const formatCoordDisplay = (latitude, longitude) => {
  const lat = parseCoordNumber(latitude);
  const lng = parseCoordNumber(longitude);
  if (lat == null || lng == null) return '—';
  return `Latitude ${lat.toFixed(6)}  ·  Longitude ${lng.toFixed(6)}`;
};

export const formatLatLongField = (latitude, longitude) => {
  const lat = latitude == null ? '' : String(latitude).trim();
  const lng = longitude == null ? '' : String(longitude).trim();
  if (!lat && !lng) return '';
  return `${lat} , ${lng}`;
};

export const parseLatLongField = (value) => {
  const parts = String(value || '').split(',').map((part) => part.trim());
  return {
    latitude: parts[0] || '',
    longitude: parts[1] || '',
  };
};

export const googleMapsUrl = (latitude, longitude) => {
  const lat = parseCoordNumber(latitude);
  const lng = parseCoordNumber(longitude);
  if (lat == null || lng == null) return null;
  return `https://www.google.com/maps?q=${encodeURIComponent(`${lat},${lng}`)}`;
};
